import { createContext, useContext } from "react";

export const CheckoutContext = createContext(null);

export function CheckoutProvider({ value, children }) {
  return (
    <CheckoutContext.Provider value={value}>
      {children}
    </CheckoutContext.Provider>
  );
}

export function useCheckoutContext() {
  const ctx = useContext(CheckoutContext);
  if (!ctx) {
    throw new Error("useCheckoutContext must be used within CheckoutProvider");
  }
  return ctx;
}
